import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const BankServices = {
  create: async (data) => {
    try {
      const response = await apiService.post(`/${slug}/bank`, data);
      return response.data;
    } catch (err) {
      console.log(err);

      // Properly throw the error message or error itself
      if (err.response && err.response.data && err.response.data.message) {
        throw new Error(err.response.data.message); // axios response error
      } else if (err.message) {
        throw new Error(err.message); // normal JS error
      } else {
        throw new Error("Something went wrong");
      }
    }
  },
  createDeposit: async (data) => {
    try {
      const response = await apiService.post(`/${slug}/bank/deposit`, data);
      return response.data;
    } catch (err) {
      console.log(err);

      // Properly throw the error message or error itself
      if (err.response && err.response.data && err.response.data.message) {
        throw new Error(err.response.data.message); // axios response error
      } else if (err.message) {
        throw new Error(err.message); // normal JS error
      } else {
        throw new Error("Something went wrong");
      }
    }
  },
  getList: async () => {
    try {
      const response = await apiService.get(`/${slug}/bank`);
      return response.data;
    } catch (err) {
      console.log(err);

      // Properly throw the error message or error itself
      if (err.response && err.response.data && err.response.data.message) {
        throw new Error(err.response.data.message); // axios response error
      } else if (err.message) {
        throw new Error(err.message); // normal JS error
      } else {
        throw new Error("Something went wrong");
      }
    }
  },

  getBankStatement: async (id, startDate, endDate) => {
    try {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const response = await apiService.get(
        `/${slug}/bank/${id}/detailswithtransactions${
          params.toString() ? "?" + params.toString() : ""
        }`
      );
      return response.data;
    } catch (err) {
      console.log(err);
      if (err.response && err.response.data && err.response.data.message) {
        throw new Error(err.response.data.message);
      } else if (err.message) {
        throw new Error(err.message);
      } else {
        throw new Error("Something went wrong");
      }
    }
  },
  detail: async (id) => {
    try {
      const response = await apiService.get(`/${slug}/purchase/${id}`);
      return response.data;
    } catch (err) {
      console.log(err);

      // Properly throw the error message or error itself
      if (err.response && err.response.data && err.response.data.message) {
        throw new Error(err.response.data.message); // axios response error
      } else if (err.message) {
        throw new Error(err.message); // normal JS error
      } else {
        throw new Error("Something went wrong");
      }
    }
  },
  update: async (id, data) => {
    try {
      const response = await apiService.put(`/${slug}/bank/${id}`, data);
      return response.data;
    } catch (err) {
      console.log(err);

      // Properly throw the error message or error itself
      if (err.response && err.response.data && err.response.data.message) {
        throw new Error(err.response.data.message); // axios response error
      } else if (err.message) {
        throw new Error(err.message); // normal JS error
      } else {
        throw new Error("Something went wrong");
      }
    }
  },
  delete: async (id) => {
    try {
      const response = await apiService.delete(`/${slug}/bank/${id}`);
      return response.data;
    } catch (err) {
      console.log(err);

      // Properly throw the error message or error itself
      if (err.response && err.response.data && err.response.data.message) {
        throw new Error(err.response.data.message); // axios response error
      } else if (err.message) {
        throw new Error(err.message); // normal JS error
      } else {
        throw new Error("Something went wrong");
      }
    }
  },
  addTransaction: async (data) => {
    try {
      const response = await apiService.post(
        `/api/countercashtransaction/addcashtocounter`,
        data
      );
      return response.data;
    } catch (err) {
      console.log(err);

      // Properly throw the error message or error itself
      if (err.response && err.response.data && err.response.data.message) {
        throw new Error(err.response.data.message); // axios response error
      } else if (err.message) {
        throw new Error(err.message); // normal JS error
      } else {
        throw new Error("Something went wrong");
      }
    }
  },
  addCounterToBankTransaction: async (data) => {
    try {
      const response = await apiService.post(
        `/api/countercashtransaction/addcashfromcountertobank`,
        data
      );
      return response.data;
    } catch (err) {
      console.log(err);

      // Properly throw the error message or error itself
      if (err.response && err.response.data && err.response.data.message) {
        throw new Error(err.response.data.message); // axios response error
      } else if (err.message) {
        throw new Error(err.message); // normal JS error
      } else {
        throw new Error("Something went wrong");
      }
    }
  },
};

export default BankServices;
